export interface IMatchOfferDeclineRootCause {
    id: number,
    description: string,
    isDateIssue: boolean,
    isNonDateIssue: boolean
}